<div class="d-flex flex-wrap mb-3 gap-1">
  @for (promo of promoLinks(); track promo.url) {
    <mat-card class="cursor-pointer" style="flex: 20%" [routerLink]="promo.url">
      <mat-card-header class="align-items-center mb-3">
        <div mat-card-avatar class="m-0 color-primary bg-primary">
          <icon [icon]="$any(promo.logo)" style="font-size: 30px; padding: 5px" />
        </div>
        <mat-card-title>{{ promo.title }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ promo.description }}</p>
      </mat-card-content>
    </mat-card>
  }
</div>

<h2>
  {{ 'Our References' | t }}
  @if (lastProjects().total > projectsLimit()) {
    <a [routerLink]="'/projects'" class="color-primary" style="font-size: medium">{{ 'View All' | t }}</a>
  }
</h2>
<div class="d-flex flex-wrap mb-3 gap-1">
  @defer (on viewport) {
    @for (project of lastProjects().items; track project._id) {
      <mat-card class="cursor-pointer" style="flex: 25%" [routerLink]="['/projects', project._id]">
        <div mat-card-image class="text-center">
          <img
            style="height: 200px; width: auto; max-width: 100%"
            [src]="project.gallery[0] | imageUrl: 'projects' : project._id"
            [alt]="project.title"
            (error)="onImgError($event)" />
        </div>
        <mat-card-content>
          <mat-card-title class="color-primary">{{ project.title }}</mat-card-title>
          <p style="height: 3.7rem; overflow: hidden">{{ project.description | stripHtml | truncate: 145 }}</p>
          <p class="bg-grey">
            <b>{{ 'Device Type' | t }}:</b> {{ project.device }}
            <br />
            <b>{{ 'Location' | t }}:</b> {{ project.location }}
            <br />
            <b>{{ 'Realization Year' | t }}:</b> {{ project.completionDate | date: 'yyyy' }}
          </p>
        </mat-card-content>
      </mat-card>
    }
  } @placeholder {
    <div></div>
  }
</div>

<mat-card class="mb-3" style="min-height: 580px">
  <mat-card-header>
    <mat-card-title>{{ 'Recommended' | t }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @defer (on viewport) {
      <div class="row row-products">
        @for (product of recProducts(); track product._id) {
          <div class="col-md-6 col-lg-4 col-xl-3">
            <div class="product-card">
              <a [routerLink]="['/p/product', product | urlLink, product._id]">
                <div class="img-fill" style="height: 200px">
                  <img [alt]="product.name" [ngSrc]="product | productImageUrl" (error)="onImgError($event)" fill />
                </div>
                <h3>{{ product.name }}</h3>
              </a>
              <div class="price">
                {{ product.price | customerPrice | localeCurrency }}
              </div>
            </div>
          </div>
        }
      </div>
    } @placeholder {
      <div></div>
    }
  </mat-card-content>
</mat-card>

<mat-card class="mb-3" style="min-height: 580px">
  <mat-card-header>
    <mat-card-title>{{ 'News' | t }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @defer (on viewport) {
      <div class="row row-products">
        @for (product of lastProducts(); track product._id) {
          <div class="col-md-6 col-lg-4 col-xl-3">
            <div class="product-card">
              <a [routerLink]="['/p/product', product | urlLink, product._id]">
                <div class="img-fill" style="height: 200px">
                  <img [alt]="product.name" [ngSrc]="product | productImageUrl" (error)="onImgError($event)" fill />
                </div>
                <h3>{{ product.name }}</h3>
              </a>
              <div class="price">
                {{ product.price | customerPrice | localeCurrency }}
              </div>
            </div>
          </div>
        }
      </div>
    } @placeholder {
      <div></div>
    }
  </mat-card-content>
</mat-card>

<mat-card class="brands" style="min-height: 95px">
  @defer (on viewport) {
    <div class="row">
      @for (item of showedBrands(); track item.label) {
        <div class="col-20">
          <div class="img-fill">
            <img [alt]="item.label" [ngSrc]="item.imageUrl" (error)="onImgError($event)" fill />
          </div>
        </div>
      }
    </div>
  } @placeholder {
    <div></div>
  }
</mat-card>
